module.exports = __webpack_public_path__ + "img/point_bg.61771273.png";